import { render } from "./ListeMonnaiesDisponibles.vue?vue&type=template&id=4d6b23c3&scoped=true&ts=true"
import script from "./ListeMonnaiesDisponibles.vue?vue&type=script&lang=ts"
export * from "./ListeMonnaiesDisponibles.vue?vue&type=script&lang=ts"

import "./ListeMonnaiesDisponibles.vue?vue&type=style&index=0&id=4d6b23c3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d6b23c3"]])

export default __exports__